import React from "react";
import "./styles.css";
import Anchor from "../anchor";
import { whatsappTramy } from "../../../constants/urls";

function PlanCard({
  icon,
  title,
  previousPricing,
  currentPricing,
  description = [],
  titleColor = "black",
  borderColor,
  features = [],
}) {
  return (
    <div
      className="plan-card__container"
      style={{
        border: borderColor,
      }}
    >
      <div className="plan-card">
        {icon}
        <div className="plan-card__wrap">
          <div className="plan-card__content">
            <h1
              style={{
                color: titleColor,
              }}
            >
              {title}
            </h1>
            <h2 className="previous-pricing">{previousPricing}</h2>
            <h2 className="current-pricing">{currentPricing}</h2>
            <span>
              <p>
                <b>Incluye:</b>
              </p>
              {description.map((sentence) => (
                <p>{sentence}</p>
              ))}
            </span>
            <ul>
              {features.map((feature) => (
                <li>{feature}</li>
              ))}
            </ul>
          </div>
          <Anchor
            background={"#109cf1"}
            color={"white"}
            text={"Acceder ahora"}
            link={whatsappTramy}
          />
        </div>
      </div>
    </div>
  );
}

export default PlanCard;
